module.exports = __webpack_public_path__ + "static/media/Horse song.b39d30b5.m4a";